import { useState } from "react";
import PhotoSizeHint from "./PhotoSizeHint";
import { addClientDocument, listClientDocuments } from "../../js/db/documents";
import { formatDate } from "../../js/utils/formatters";
import { useGuestMode } from "../../js/hooks/useGuestMode";
import GuestLockShell from "../guest/GuestLockShell";

export default function ClientDocuments({ ownerId, role = "buyer" }) {
  const [rows, setRows] = useState(() => listClientDocuments(ownerId, role));
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { canPersist, openGuestLock } = useGuestMode();

  async function handleFile(event) {
    const file = event.target.files?.[0];
    event.target.value = "";
    if (!canPersist) {
      openGuestLock();
      return;
    }
    if (!file || !ownerId) return;
    setBusy(true);
    setError("");
    try {
      await addClientDocument({
        ownerId,
        role,
        file,
        kind: String(file.type || "").startsWith("image/") ? "photo" : "document",
      });
      setRows(listClientDocuments(ownerId, role));
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <GuestLockShell>
      <section className="card">
        <h2>Documents & photos</h2>
        <p className="muted">Saved with this account so your agent can open them from any signed-in desk.</p>
        {ownerId ? (
          <label className="field">
            <span className="field-label">Add a file or photo</span>
            <input type="file" accept="image/*,.pdf,.doc,.docx,.txt" onChange={handleFile} disabled={busy || !canPersist} />
          </label>
        ) : (
          <p className="muted">Sign in to keep documents and photos with this account.</p>
        )}
        <PhotoSizeHint />
        {error ? <p className="field-error">{error}</p> : null}
        {rows.length ? (
          <ul className="stack" style={{ listStyle: "none", padding: 0 }}>
            {rows.map((row) => (
              <li key={row.id}>
                {row.file_name}
                <div className="muted">{formatDate(row.created_at)}</div>
              </li>
            ))}
          </ul>
        ) : ownerId ? (
          <p className="muted">No documents or photos saved yet.</p>
        ) : null}
      </section>
    </GuestLockShell>
  );
}
